import React from "react";
import "./lifeExamples.scss";
import { Row, Col } from "reactstrap";

class LifeExamples extends React.Component {
  // constructor(props) {
  //     super(props)
  // }
  render() {
    return (
      <div className="life-examples-container">
        <Row className="m-0 p-0">
          <Col lg={6} className="m-0 p-0 left-section">
            <img
              src={require("../../../assets/images/icons/people.png")}
              alt=""
            />
            <h2 className="title">Geeta (age 33)</h2>
            <h3 className="sub-title">New Delhi, Delhi</h3>
            <h3 className="story">
              <span className="font-italic">
                Geeta, a happy housewife and a mother-of-two decided to protect
                her family’s future and long-term happiness and bought a Premium
                Life Insurance Plan at Toffee Insurance on her birthday. A month
                back, her husband had an accident while coming back from work.
                Though her husband’s workplace offered insurance, the daily
                capping on the expenses was really marginal to what Geeta and
                her husband needed for financial assurance.
              </span>
              <br />
              <br />
              Thanks to Geeta’s Premium Life Insurance Plan, all the
              hospitalisation charges as well as indirect expenses like nursing,
              transportation was covered and reimbursed for. Today, Geeta and
              her husband both are healthy and understand the importance of
              having a policy that is actually as per your needs instead of a
              regular life insurance plan.
            </h3>
          </Col>
          <Col lg={6} className="m-0 p-0  right-section">
            <img
              src={require("../../../assets/images/icons/people.png")}
              alt=""
            />
            <h2 className="title">Ravi (age 35)</h2>
            <h3 className="sub-title">Jaipur, Rajasthan</h3>
            <h3 className="story">
              <span className="font-italic">
                Ravi supports his nuclear family of 4 with his job as a Graphic
                Designer. Last year, Ravi was diagnosed with Dengue and had to
                be hospitalised for platelet transfer for 17 days.
              </span>
              <br />
              <br />
              Post recuperating, Ravi filed a claim with Toffee Insurance for
              his Smart Life plan, and submitted his medical reports. Within 3
              days, Ravi’s claims were settled with ₹50,000 toward his
              hospitalisation expenses and ₹2,500 for his blood tests and
              medicine expenses. In addition, he also received a total sum of
              ₹34,000 for his 17-day stay at the hospital.
              <br />
              <br />
              With one smart decision, Ravi could surpass the financial hiccup
              with this whole experience as well as reduce his worries from the
              loss of health and income.
            </h3>
          </Col>
        </Row>
      </div>
    );
  }
}

export default LifeExamples;
